<template>
  <div class="c">
    <div class="c-left">
      <SubjectCount titleName="资源科目分布" :user="count" />
      <ResourceGradeUser
        class="mt"
        titleName="资源年级分布"
        :userGradeList="userGradeList"
        :userGradeCount="userGradeCount"
      />
      <school-top class="mt" />
    </div>
    <div class="c-center">
      <header class="map-header">
        <p class="map-header__title">教育资源配置</p>
        <div style="text-align: center;">
          <span class="map-header__people">教育资源总量（累计）:</span>
          <span :class="{'map-header__text': item!== ',',
          'map-header__bottom': item  === ','}"
            v-for="(item, index) in numberChange()"
            :key="index"
          >{{item}}</span>
        </div>
      </header>
      <div class="content">
        <ul class="content-left">
          <li class="mt-32">
            <p>课 件</p>
            <p>465,783</p>
          </li>
          <li class="mt-57">
            <p>讲 义</p>
            <p>567,590</p>
          </li>
          <li class="mt-45">
            <p>知识点视频</p>
            <p>256,342</p>
          </li>
        </ul>
        <ul class="content-right">
          <li class="mt-32">
            <p>题 目</p>
            <p>3,678,903</p>
          </li>
          <li class="mt-57">
            <p>微 课</p>
            <p>364,293</p>
          </li>
          <li class="mt-45">
            <p>素 材</p>
            <p>1,679,832</p>
          </li>
        </ul>
      </div>
      <div class="content-footer"></div>
    </div>
    <div class="c-right">
      <!-- <accurate-study /> -->
      <adapt-study title="资源使用" />
      <HotSubjectTop class="mt-10" />
      <resourceEcharts
        class="mt-10"
        titleName="资源被使用种类"
        :userTypeList="userTypeList"
        :userTypeCount="userTypeCount"
      />
    </div>
  </div>
</template>

<script>
import SchoolTop from './school-type.vue';
// import AccurateStudy from './accurate-study.vue';
import AdaptStudy from './adapt-study.vue';
// import InformationStatistics from './information-statistics.vue';
import SubjectCount from './subject-count.vue';
import resourceEcharts from './resource-echarts.vue';
import ResourceGradeUser from './resource-grade-user.vue';
import HotSubjectTop from './hot-subject-top.vue';

export default {
  name: 'ResourceAllocation',
  components: {
    SchoolTop,
    // AccurateStudy,
    AdaptStudy,
    // InformationStatistics,
    SubjectCount,
    resourceEcharts,
    HotSubjectTop,
    ResourceGradeUser,
  },
  data() {
    return {
      count: [1349061, 2018734, 1576385, 1109465, 959098],
      userGradeList: ['三年级', '四年级', '五年级', '六年级', '七年级', '八年级'],
      userGradeCount: [
        { value: 13.2, name: '三年级' },
        { value: 15.4, name: '四年级' },
        { value: 18.3, name: '五年级' },
        { value: 21.9, name: '六年级' },
        { value: 11.7, name: '七年级' },
        { value: 19.5, name: '八年级' },
        // { value: 9685, name: '九年级' },
      ],
      userTypeList: ['课件', '讲义', '知识点视频', '题目', '微课', '素材'],
      userTypeCount: [
        { value: 13.6, name: '课件' },
        { value: 15.1, name: '讲义' },
        { value: 10.6, name: '知识点视频' },
        { value: 27.5, name: '题目' },
        { value: 10.4, name: '微课' },
        { value: 22.8, name: '素材' },
      ],
      peopleNumber: 7012743,
    };
  },
  methods: {
    numberChange() {
      return Number(this.peopleNumber).toLocaleString();
    },
  },
};
</script>

<style lang="scss" scoped>
.c {
  width: 100%;
  height: 100%;
  display: flex;
  &-left {
    width: 402px;
    display: flex;
    flex-direction: column;
    // justify-content: space-evenly;
  }
  &-center {
    flex: 1;
    background: url("../../images/exhibition-resource.png") no-repeat center
      bottom;
    background-size: 985px 701px;
    position: relative;
    .content {
      box-sizing: border-box;
      padding: 0 90px;
      width: 100%;
      height: 450px;
      background: url("../../images/exhibition-extend.png") no-repeat center
        bottom;
      background-size: 941px 374px;
      position: absolute;
      bottom: 265px;
      display: flex;
      justify-content: space-between;
      ul {
        li {
          // margin-bottom: 53px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #f5f5ff;
          line-height: 40px;
          letter-spacing: 1px;
          text-align: center;
        }
      }
    }
    .map-header {
      box-sizing: border-box;
      height: 154px;
      padding: 0 20px 20px 20px;
      color: #f5f5f5;
      &__title {
        font-size: 30px;
        font-weight: 500;
        color: #F5F5FF;
        line-height: 100px;
        letter-spacing: 3px;
        text-align: center;
      }
      &__people {
        display: inline-block;
        letter-spacing: 2px;
        margin-right: 10px;
        line-height: 58px;
        font-size: 16px;
        position: relative;
        top: -10px;
      }
      &__text {
        text-align: center;
        display: inline-block;
        width: 44px;
        height: 58px;
        line-height: 58px;
        margin-right: 10px;
        color: #f5f5f5;
        font-size: 50px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        background: linear-gradient(180deg, #0A54EA 0%, #4D07CF 100%);
        border-radius: 2px;
        border: 1px solid rgba(112, 65, 255, 1);
        border-image: linear-gradient(180deg, rgba(55, 110, 255, 1), rgba(112, 65, 255, 1)) 1 1;
      }
      &__bottom {
        font-size: 50px;
        margin-right: 10px;
      }
    }
    .content-footer {
      width: 12%;
      height: 122px;
      background: url("../../images/exhibition-star.png") no-repeat;
      background-size: 122px;
      position: absolute;
      bottom: 265px;
      left: 478px;
      animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
    0% {
        transform: scale();
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale();
    }
}
  }
  &-right {
    width: 402px;
    display: flex;
    flex-direction: column;
    // justify-content: space-evenly;
  }
}
  .mt {
    margin-top: 26px;
      }
  .mt-10 {
    margin-top: 40px;
  }
</style>
